export const AuditsRoutes = {
  AuditRuns: '/audits/runs',
};
